// Oportunidades 2027 (docs/oportunidades-2027): lista L1/L2 + liga os componentes dos Tickets com o mapa op-* (DD-04, dd04-mapa.md M2..M9).
// - Ordem do init = main.js dos Tickets: SaidaDetalhe (captura em window) → FilaSelecao → PainelOlho → TelaPaineis → os ouvintes desta página.
// - Abrir um card (vista Cards): GET do EP-02 aqui, sem .bt-ajax: falha de rede, 504, corpo não-JSON (die() de provider) e `error` viram
//   estado nomeado no detalhe (E-D3/E-D4/E-D5), nunca reload nem tela quebrada. O `disabled` do botão imita o do .bt-ajax: o FilaSelecao
//   destrava a fila quando ele sai (FilaSelecao.js, `vigia`). Funil/Tabela: GET da página com `sel` (urlSel do view-model).
// - Paginação da vista Cards pelo EP-06 (troca só os filhos do #op-lista; a URL acompanha com pushState). Filtros e busca: GET do form.
// - Boxes B-2/B-3 pelo EP-03 (null = "—" + title). Cor de tag (DD-11) vem em data-cor e vira --op-tag-cor aqui.
// - Resumo de pedidos NV-01 (ui.md DD-16/E-D10, contrato EP-07): GET próprio pelo pedir() quando o detalhe chega. Só `code:"ok"` com 4 .tk-num
//   entra; todo o resto é E-D10d (com "Tentar de novo") ou E-D10e (sessão). Resposta de um detalhe que já saiu é descartada (nó fora do documento).
// - Conversa do centro (ui-conversa DD-17..DD-19, contrato EP-08): GET próprio pelo pedir() na raiz #op-conversa-chat. Só `code:"ok"` com html e
//   chatRoom injeta (pelo MESMO replaceContent do Tickets, no Opportunity.js, evento op:conversa); `sem_canal` = E-D11b; todo o resto = E-D11c
//   ("Tentar de novo"); 419/redirect = E-D11f. Com 2+ canais, chip "Canal" no fim da linha 1 da .op-faixa; trocar passa pela guarda de descarte
//   do SaidaDetalhe e faz 1 GET na `url` do canal (com `target`). Âncora no fim = ConversaFim.ancorar (DD-19). Resposta velha é descartada.
// Textos: todos no DOM (data-* e <template> das blades); este arquivo não tem texto de tela.

const SaidaDetalhe = require('./SaidaDetalhe');
const FilaSelecao = require('./FilaSelecao');
const PainelOlho = require('./PainelOlho');
const TelaPaineis = require('./TelaPaineis');
const ConversaFim = require('./ConversaFim');
const PosAcao = require('./PosAcao');   // C-16 DD-30 (ui-posacao.md): ações A-08/A-09 pelo EP-09, ficando na tela nova

const NADA = ':not(*)';   // seletor válido que não casa nada (dd04-mapa.md M2)
const TEMPO_MS = 30000;
// Orçamento do GET do resumo de pedidos (NV-01, EP-07). Ponto ÚNICO de ajuste: o pior caso do servidor (~40 s + hooks, contrato EP-07)
// passa dele, e o Dev PHP vai recomendar o valor (revisão ciclo 02, R-3). Hoje = o mesmo dos outros GET da página.
const RESUMO_TEMPO_MS = 30000;
const CONVERSA_TEMPO_MS = 30000;   // EP-08: prazo do servidor 25 s (contrato C-13) + folga; o mesmo dos outros GET da página
const ICONE_OK = /^[A-Za-z0-9 _-]+$/;   // EP-08 `icone` = lista de classes; outra forma não vira classe (nunca HTML)

const MAPA = {
    saida: {
        filaId: 'op-fila', statusId: 'op-status', detalhe: '.op-detalhe', aberto: '.op-detalhe .op-barra[data-ticket]', barra: '.op-barra[data-ticket]',
        lista: '#op-lista', item: '.op-card', abrir: '.op-card-abrir',
        vazio: NADA,         // sem <p> vazio: o gancho aoEsvaziar volta à lista (M8)
        assumirItem: NADA, assumir: NADA, proximo: NADA, camada: NADA,   // sem Assumir, sem "Atender o próximo", sem camada D19
        tela: '.op-tela', voltar: '.op-barra-voltar', attrPainel: 'data-painel', buscaForm: 'form.op-form', corpo: '.op-corpo',
        olhoTextos: NADA, olhoAnexos: NADA,   // a janela 5 é ficha, sem compositor (DD-13)
    },
    fila: {
        tela: '.op-tela', attrPainel: 'data-painel', barra: '.op-barra[data-ticket]', item: '.op-card', itemClasse: 'op-card', proximo: NADA,
        abrir: '.op-card-abrir', filaId: 'op-fila', lista: '#op-lista', listaId: 'op-lista', nome: '.op-card-nome', detalhe: '.op-detalhe', listaGuarda: '.op-lista',
    },
    olho: {
        tela: '.op-tela', detalhe: '.op-detalhe', ctx: '.op-ctx', corpo: '.op-corpo', lista: '#op-lista', item: '.op-card', abrir: '.op-card-abrir',
        nome: '.op-card-nome', assunto: NADA, aberto: '.op-detalhe .op-barra[data-ticket]', gatilho: '.op-barra-olho',
        head: NADA, nums: NADA, headUser: NADA,   // barra de 3 linhas (padding 20 fixo, UI-31); números não se repetem na janela 5 (DD-13)
        buscaCampo: '#op-fila .op-busca input[type="search"]', filaId: 'op-fila', olhoId: 'op-olho', olhoIn: '.op-olho-in', trilhoId: 'op-trilho',
        trilhoLista: NADA, trilhoAbrir: NADA, trilhoItem: NADA,   // sem trilho de iniciais (PD-24); o #op-trilho existe vazio (PainelOlho:449/:505)
        veu: ':scope > .op-olho-veu', veuTopo: 'op-olho-veu-topo', linhaGrade: NADA,   // a grade é a própria .op-tela (DD-01)
        olhoTitId: 'op-olho-tit', olhoTit: 'op-olho-tit', olhoHead: 'op-olho-head', olhoCorpo: 'op-olho-corpo', olhoX: 'op-olho-x', olhoL1: 'op-olho-l1',
        olhoEsq: 'op-olho-esq', olhoEsqLinha: 'op-olho-esq-linha', olhoEsqTxt: 'op-olho-esq-txt', olhoEsqIco: 'op-olho-esq-ico',
        olhoMsg: 'op-olho-msg', olhoAcao: 'op-olho-acao', olhoTentar: 'op-olho-tentar', olhoMudou: 'op-olho-mudou',
        cliTentar: NADA, olhoForm: NADA, olhoTexto: NADA, olhoAnexoNome: NADA, olhoDocs: NADA, olhoPe: NADA, olhoSel: NADA,   // ramos de ticket/pedido
    },
    paineis: {
        tela: '.op-tela', detalhe: '.op-detalhe', detalheBloco: '.op-detalhe', corpo: '.op-corpo', ctx: '.op-ctx', ctxBtn: '.op-barra-ctx',
        conversaBtn: '.op-barra-conversa', ctxFechar: '.op-ctx-fechar', voltar: '.op-barra-voltar', attrPainel: 'data-painel',
        item: '.op-card', abrir: '.op-card-abrir', buscaCampo: '#op-fila .op-busca input[type="search"]',
        faixaDados: NADA,   // a faixa de ação quebra linha (DD-07): sem Select2 em faixa que rola
    },
};

const Oportunidades27 = function () {

    const $ = window.jQuery;
    let tela, fila, lista, det;
    let seq = 0;
    let contado = false;   // EP-03 só com os boxes à vista (L1): em L2 eles estão escondidos (CA-30, custo)
    // C-12 (DD-20): "Detalhes" aberto/fechado vale enquanto a página vive — abrir outra oportunidade nasce no mesmo estado; recarregar = fechado.
    // Nada em storage. Fora do regime compacto o botão é display:none e o atributo não age (a folha só esconde dentro do mixin op-compacta).
    let detalhesAberto = false;
    const aplicarDetalhes = (raiz) => {
        const b = raiz ? raiz.querySelector(':scope > .op-barra > .op-barra-resumo') : null;
        if (b) b.setAttribute('aria-expanded', detalhesAberto ? 'true' : 'false');
    };

    const HEX = /^#[0-9a-f]{3}([0-9a-f]{3})?$/i;
    const pintarTags = (raiz) => {
        (raiz || document).querySelectorAll('.op-tag-cor[data-cor]').forEach((el) => { if (HEX.test(el.dataset.cor)) el.style.setProperty('--op-tag-cor', el.dataset.cor); });
    };
    const ligarPopovers = (raiz) => {
        if (!$ || !$.fn || !$.fn.popover) return;
        $(raiz || document).find('.op-pop[data-toggle="popover"]').popover({ html: false, trigger: 'focus', placement: 'top' });
    };
    const clonar = (id) => { const t = document.getElementById(id); return t ? t.content.cloneNode(true) : null; };
    const trocarDetalhe = (nos) => { if (ConversaFim.soltar) ConversaFim.soltar(); if ($) $(det).empty().append(nos); else det.replaceChildren(nos); };
    const vista = () => tela.dataset.vista || 'cards';
    // Bloco D: toda troca do miolo do detalhe (chegou, estado de erro, fechou) avisa o Opportunity.js (resources/js/pages), que deixa a
    // sala do chat anterior e carrega os .cardLoad do painel novo com a MESMA cardLoad() da tela antiga (CA-21, contrato A-12).
    // `code` = result.code do EP-02 só quando o painel chegou (ok); nos estados e no fechar fica null.
    const avisar = (id, ok, code) => document.dispatchEvent(new CustomEvent('op:detalhe', { detail: { id: id, ok: ok, raiz: det, code: code || null } }));
    // F-99 (contrato C-07, "o que o Front dispara"): a mesma coisa que o GeoLocation.js faz na página do detalhe antigo, uma vez por
    // abertura (EP-02 sem `parte`, error:false, code "ok"). url/tipo vêm do header.op-barra (data-geo-*, só quando $geolocalizacao ≠ null).
    // Não usa GeoLocation.init(): ele lê o 1º .store-geolocation do documento, que aqui é o <body> da LISTA (tipo 2, F-32).
    // Resposta e erro ignorados, como na antiga; sem API de geolocalização ou permissão negada, nada sai.
    const tipoComoJquery = (t) => (t !== undefined && t === String(+t) ? +t : t);   // o .data() do jQuery: "3" → 3
    const geolocalizar = (e) => {
        const d = e.detail || {};
        if (!d.ok || d.code !== 'ok' || !d.raiz) return;
        const barra = d.raiz.querySelector(':scope > header.op-barra[data-geo-url]');
        if (!barra || !barra.dataset.geoUrl || !navigator.geolocation || !window.axios) return;
        const url = barra.dataset.geoUrl;
        const tipo = tipoComoJquery(barra.dataset.geoTipo);
        navigator.geolocation.getCurrentPosition((pos) => {
            window.axios.post(url, { latitude: pos.coords.latitude, longitude: pos.coords.longitude, location_type_id: tipo }).then(() => {}, () => {});
        });
    };
    const semSel = () => { const u = new URL(location.href); u.searchParams.delete('sel'); return u.toString(); };

    // Pedido GET com orçamento de tempo. Resolve SEMPRE { ok, json } ou { ok:false, motivo } (rede, 30 s, HTTP ≠ 200 — 504 incluso —, 419/redirect, corpo não-JSON).
    const pedir = (url, tempoMs) => {
        const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const relogio = ctrl ? setTimeout(() => ctrl.abort(), tempoMs || TEMPO_MS) : null;
        return fetch(url, { method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, signal: ctrl ? ctrl.signal : undefined })
            .then((r) => {
                if (r.status === 419 || r.redirected) return { ok: false, motivo: 'sessao' };
                if (!r.ok) return { ok: false, motivo: 'http' };
                return r.text().then((txt) => {
                    let j = null;
                    try { j = JSON.parse(txt); } catch (e) { return { ok: false, motivo: 'nao_json' }; }
                    return j && typeof j === 'object' && j.result && typeof j.result === 'object' ? { ok: true, json: j } : { ok: false, motivo: 'nao_json' };
                });
            })
            .catch(() => ({ ok: false, motivo: 'rede' }))
            .finally(() => { if (relogio) clearTimeout(relogio); });
    };

    // ---------- resumo de pedidos NV-01 (EP-07) ----------
    // Esqueleto original (E-D10a) guardado por bloco: o "Tentar de novo" volta a ele antes de refazer o GET. `pedidoDe` = o pedido vigente do bloco.
    const esqueletoDe = new WeakMap();
    const pedidoDe = new WeakMap();
    const resumoErro = (bloco, sessao) => {
        const f = clonar(sessao ? 'op-tpl-ped-sessao' : 'op-tpl-ped-erro');
        const caixa = f ? f.firstElementChild : null;
        bloco.removeAttribute('aria-busy');
        bloco.dataset.estado = sessao ? 'sessao' : 'erro';
        if (caixa) bloco.replaceChildren(caixa); else bloco.replaceChildren();
    };
    // html do EP-07 com code ok: exatamente 4 div.tk-num e nada mais (a partial do Tickets); outra forma = E-D10d, nunca meia tela.
    const quatroNumeros = (html) => {
        if (typeof html !== 'string' || html.trim() === '') return null;
        const t = document.createElement('template');
        t.innerHTML = html;
        const els = Array.from(t.content.children);
        return els.length === 4 && els.every(n => n.tagName === 'DIV' && n.classList.contains('tk-num')) ? t.content : null;
    };
    const carregarResumo = (bloco) => {
        const url = bloco.dataset.resumoUrl;
        if (!url) return;
        if (!esqueletoDe.has(bloco)) esqueletoDe.set(bloco, Array.from(bloco.children).map(n => n.cloneNode(true)));
        else bloco.replaceChildren(...esqueletoDe.get(bloco).map(n => n.cloneNode(true)));
        bloco.setAttribute('aria-busy', 'true');
        bloco.dataset.estado = 'carregando';
        const meu = {};
        pedidoDe.set(bloco, meu);
        pedir(url, RESUMO_TEMPO_MS).then((o) => {
            if (!bloco.isConnected || pedidoDe.get(bloco) !== meu) return;   // outra oportunidade abriu, ou um "Tentar" mais novo
            const j = o.ok ? o.json : null;
            const nums = j && j.error === false && j.result.code === 'ok' ? quatroNumeros(j.result.html) : null;
            if (!nums) { resumoErro(bloco, !o.ok && o.motivo === 'sessao'); return; }
            bloco.removeAttribute('aria-busy');
            bloco.dataset.estado = 'ok';
            bloco.replaceChildren(nums);
        });
    };

    // ---------- conversa do centro (EP-08, ui-conversa DD-17..DD-19) ----------
    // `esqConversa` = o "Carregando a conversa…" que veio no html (E-D11a), reposto a cada GET. `pedidoConversa` = o pedido vigente da raiz.
    // `canaisDe` = a lista de canais do 1º GET (o GET da `url` de um canal não traz a lista). `ultimoGet` = o que o "Tentar de novo" refaz.
    const esqConversa = new WeakMap();
    const pedidoConversa = new WeakMap();
    const canaisDe = new WeakMap();
    const ultimoGet = new WeakMap();
    const comAlvo = (url, raiz) => { const u = new URL(url, location.href); u.searchParams.set('target', '#' + raiz.id); return u.toString(); };
    const chipDe = (cv) => { const c = cv.parentElement; return c ? c.querySelector(':scope > .op-faixa .op-canais') : null; };
    const chipOcupado = (cv, sim) => {
        const w = chipDe(cv);
        const b = w ? w.querySelector('.op-canal') : null;
        if (!b) return;
        if (sim) { b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); b.classList.add('disabled'); }   // .disabled: o BS4 não abre
        else { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); b.classList.remove('disabled'); }
    };
    // tira o chip e a .op-faixa que só existia por causa dele (data-so-canal)
    const tirarCanais = (cv) => {
        const c = cv.parentElement;
        if (!c) return;
        c.querySelectorAll(':scope > .op-faixa[data-so-canal]').forEach(n => n.remove());
        c.querySelectorAll(':scope > .op-faixa .op-canais').forEach(n => n.remove());
    };
    const conversaEstado = (raiz, cv, tpl, nome) => {
        if (ConversaFim.soltar) ConversaFim.soltar();
        const f = clonar(tpl);
        const caixa = f ? f.firstElementChild : null;
        raiz.removeAttribute('aria-busy');
        cv.dataset.estado = nome;
        if (caixa) raiz.replaceChildren(caixa); else raiz.replaceChildren();
        chipOcupado(cv, false);
    };
    const pintarIcone = (i, icone) => { i.className = i.className.split(' ')[0] + (typeof icone === 'string' && ICONE_OK.test(icone) ? ' ' + icone : ''); };
    const marcarCanal = (cv, canal) => {
        const w = chipDe(cv);
        if (!w || !canal) return;
        const b = w.querySelector('.op-canal');
        const nome = String(canal.nome == null ? '' : canal.nome);
        w.querySelector('.op-canal-nome').textContent = nome;   // textContent: `nome` vem cru do EP-08
        pintarIcone(w.querySelector('.op-canal-ico'), canal.icone);
        b.setAttribute('aria-label', String(b.dataset.aria || '').replace(':canal', nome));
        w.querySelectorAll('.op-canal-item').forEach(it => it.setAttribute('aria-checked', it.dataset.canal === String(canal.id) ? 'true' : 'false'));
    };
    // DD-18: só com 2+ canais válidos. Sem .op-faixa (tipo 3, sem etapa): ela nasce só com a linha 1 e o chip ([data-so-canal]).
    const desenharCanais = (raiz, cv, canais, atual) => {
        tirarCanais(cv);
        const lista = (Array.isArray(canais) ? canais : []).filter(c => c && Number.isInteger(c.id) && c.id > 0 && typeof c.url === 'string' && c.url !== '');
        canaisDe.set(raiz, lista);
        const centro = cv.parentElement;
        if (lista.length < 2 || !centro) return;
        const f = clonar('op-tpl-canais');
        const w = f ? f.firstElementChild : null;
        if (!w) return;
        const menu = w.querySelector('.op-canais-menu');
        lista.forEach((c) => {
            const fi = clonar('op-tpl-canal-item');
            const it = fi ? fi.firstElementChild : null;
            if (!it) return;
            it.dataset.canal = String(c.id);
            it.querySelector('.op-canal-item-nome').textContent = String(c.nome == null ? '' : c.nome);
            pintarIcone(it.querySelector('.op-canal-item-ico'), c.icone);
            menu.appendChild(it);
        });
        let faixa = centro.querySelector(':scope > .op-faixa');
        if (!faixa) { faixa = document.createElement('div'); faixa.className = 'op-faixa'; faixa.setAttribute('data-so-canal', ''); centro.insertBefore(faixa, cv); }
        let l1 = faixa.querySelector(':scope > .op-faixa-l1');
        if (!l1) { l1 = document.createElement('div'); l1.className = 'op-faixa-l1'; faixa.insertBefore(l1, faixa.firstChild); }
        l1.appendChild(w);
        marcarCanal(cv, lista.find(c => c.id === atual) || lista[0]);
    };
    // GET da conversa: o do EP-08 (canal = null) ou o da `url` de um canal (troca, DD-18). Resposta de outra oportunidade, de outro canal
    // escolhido depois ou de um "Tentar" mais novo é descartada (raiz fora do documento ou pedido vigente ≠ este).
    const carregarConversa = (raiz, url, canal) => {
        const cv = raiz.parentElement;
        if (!cv || !url) return;
        if (!esqConversa.has(raiz)) esqConversa.set(raiz, Array.from(raiz.childNodes).map(n => n.cloneNode(true)));
        if (ConversaFim.soltar) ConversaFim.soltar();
        raiz.replaceChildren(...esqConversa.get(raiz).map(n => n.cloneNode(true)));
        raiz.setAttribute('aria-busy', 'true');
        cv.dataset.estado = 'carregando';
        chipOcupado(cv, true);
        const meu = {};
        pedidoConversa.set(raiz, meu);
        ultimoGet.set(raiz, { url: url, canal: canal });
        pedir(canal ? comAlvo(url, raiz) : url, CONVERSA_TEMPO_MS).then((o) => {
            if (!raiz.isConnected || pedidoConversa.get(raiz) !== meu) return;
            const j = o.ok ? o.json : null;
            const r = j ? j.result : null;
            const forma = !!r && j.error === false && typeof r.html === 'string' && r.html.trim() !== '' && typeof r.chatRoom === 'string' && r.chatRoom !== '';
            const ok = canal ? forma : forma && r.code === 'ok';
            if (!ok) {
                if (!o.ok && o.motivo === 'sessao') conversaEstado(raiz, cv, 'op-tpl-conversa-sessao', 'sessao');
                else if (!canal && r && r.code === 'sem_canal') { tirarCanais(cv); conversaEstado(raiz, cv, 'op-tpl-conversa-sem-canal', 'sem-canal'); }
                else conversaEstado(raiz, cv, 'op-tpl-conversa-erro', 'erro');
                return;
            }
            const d = { raiz: raiz, feito: false, envelope: { error: false, message: '', result: { method: 'replaceContent', target: '#' + raiz.id, html: r.html, chatRoom: r.chatRoom } } };
            document.dispatchEvent(new CustomEvent('op:conversa', { detail: d }));
            if (!d.feito) { conversaEstado(raiz, cv, 'op-tpl-conversa-erro', 'erro'); return; }   // sem o hospedeiro (app.js): erro visível, nunca meia tela
            raiz.removeAttribute('aria-busy');
            cv.dataset.estado = 'carregada';
            const L = raiz.querySelector('.messages-chat-whats');
            if (L && ConversaFim.ancorar) ConversaFim.ancorar(L);
            if (!canal) desenharCanais(raiz, cv, r.canais, r.canalAtual);
            else marcarCanal(cv, canal);
            chipOcupado(cv, false);
        });
    };
    const trocarCanal = (item) => {
        const w = item.closest('.op-canais');
        const centro = w ? w.closest('.op-centro') : null;
        const raiz = centro ? centro.querySelector(':scope > .op-conversa > #op-conversa-chat') : null;
        const chip = w ? w.querySelector('.op-canal') : null;
        if (!raiz || !chip || chip.classList.contains('disabled')) return;
        const canal = (canaisDe.get(raiz) || []).find(c => String(c.id) === item.dataset.canal);
        if (!canal || item.getAttribute('aria-checked') === 'true') return;
        const seguir = () => {
            if (!raiz.isConnected) return;
            marcarCanal(raiz.parentElement, canal);
            carregarConversa(raiz, canal.url, canal);
            chip.focus({ preventScroll: true });
        };
        const m = SaidaDetalhe.motivoClique();   // a MESMA guarda de trocar de oportunidade (texto, anexo, gravação)
        if (m === 'ocupado') return;
        if (!m) { seguir(); return; }
        SaidaDetalhe.perguntarDescarte(m, chip).then((ok) => { if (ok) seguir(); });
    };
    // R-24: o menu abre para baixo, dentro do .op-centro; a altura cabe no que sobra até o fim dele (máx. 240), com rolagem própria
    const medirMenuCanais = (e) => {
        const w = e.target instanceof Element ? e.target.closest('.op-canais') : null;
        const centro = w ? w.closest('.op-centro') : null;
        const menu = w ? w.querySelector('.op-canais-menu') : null;
        if (!centro || !menu) return;
        const livre = centro.getBoundingClientRect().bottom - w.getBoundingClientRect().bottom - 12;
        menu.style.maxHeight = Math.max(72, Math.min(240, Math.floor(livre))) + 'px';
    };

    // ---------- detalhe (abrir pela lista; o Bloco D desenha o miolo) ----------
    const estado = (tpl, id, urlTentar, urlPagina) => {
        const f = clonar(tpl);
        if (!f) return;
        const barra = f.querySelector('.op-barra');
        if (barra && id) barra.dataset.ticket = String(id);   // E-D3/E-D4/E-D5: × e Esc fecham como o degrau 4 (UI-51)
        const tentar = f.querySelector('.op-estado-tentar');
        if (tentar) { if (urlTentar) tentar.dataset.url = urlTentar; else tentar.remove(); }
        const pag = f.querySelector('.op-estado-pagina');
        if (pag) { if (urlPagina) pag.href = urlPagina; else pag.remove(); }
        trocarDetalhe(f);
        avisar(id, false);
    };
    const abrir = (btn, url, urlSel, id, urlPagina) => {
        const meu = ++seq;
        if (btn) btn.setAttribute('disabled', 'disabled');
        tela.dataset.estagio = 'encolhida';
        tela.setAttribute('data-carregando', '');
        det.setAttribute('aria-busy', 'true');
        if (urlSel) history.replaceState(history.state, '', urlSel);
        return pedir(url).then((o) => {
            if (meu !== seq) return;
            tela.removeAttribute('data-carregando');
            det.removeAttribute('aria-busy');
            const j = o.ok ? o.json : null;
            if (j && !j.error && typeof j.result.html === 'string' && j.result.html.trim() !== '') {
                if (ConversaFim.soltar) ConversaFim.soltar();
                if ($) $(det).html(j.result.html); else det.innerHTML = j.result.html;
                aplicarDetalhes(det);
                pintarTags(det);
                const resumo = det.querySelector(':scope > .op-barra .op-barra-nums[data-resumo-url]');
                if (resumo) carregarResumo(resumo);
                const conversa = det.querySelector('.op-centro > .op-conversa > #op-conversa-chat[data-url]');
                avisar(id, true, j.result.code);
                if (conversa) carregarConversa(conversa, conversa.dataset.url, null);
            } else {
                const code = j && j.result ? j.result.code : null;
                if (code === 'sem_acesso' || code === 'sem_permissao') estado('op-tpl-ed3', id, null, null);
                else if (code === 'nao_encontrada') estado('op-tpl-ed4', id, null, null);
                else estado('op-tpl-ed5', id, url, urlPagina);   // falha, rede, 504, corpo não-JSON, sessão
            }
        }).finally(() => { if (btn) btn.removeAttribute('disabled'); });
    };

    // SaidaDetalhe:213-216 (M8): fechar = voltar a L1. Cards: na página, sem `sel`; Funil/Tabela: GET da vista sem `sel`.
    const aoEsvaziar = (d) => {
        seq++;
        tela.removeAttribute('data-carregando');
        if (ConversaFim.soltar) ConversaFim.soltar();
        if ($) $(d).empty(); else d.replaceChildren();
        avisar(null, false);
        if (vista() !== 'cards') { location.assign(semSel()); return; }
        tela.dataset.estagio = 'cheia';
        tela.removeAttribute('data-painel');
        history.replaceState(history.state, '', semSel());
        contar();
    };

    // ---------- fila por AJAX (EP-06) ----------
    const avisoFila = (url) => {
        lista.querySelectorAll(':scope > .op-aviso-fila').forEach(n => n.remove());
        const f = clonar('op-tpl-fila-erro');
        if (!f) return;
        const b = f.querySelector('.op-fila-tentar');
        if (b) b.dataset.url = url;
        lista.insertBefore(f, lista.firstChild);
    };
    // CA-22 (R-1): o link da paginação traz o `sel` da requisição que o RENDERIZOU; quem manda é o `sel` da URL atual (escrito pelo
    // abrir/fechar). Normalizado ANTES do EP-06, do pushState e do assign — os três recebem o mesmo endereço.
    const comSelAtual = (href) => {
        const nu = new URL(href, location.href);
        const cur = new URL(location.href).searchParams.get('sel');
        if (cur) nu.searchParams.set('sel', cur); else nu.searchParams.delete('sel');
        return nu.toString();
    };
    const paginar = (bruto) => {
        const href = comSelAtual(bruto);
        const base = fila.dataset.urlFila;
        if (!base) { location.assign(href); return; }
        const u = new URL(base, location.href);
        u.search = new URL(href).search;
        lista.setAttribute('aria-busy', 'true');
        pedir(u.toString()).then((o) => {
            lista.removeAttribute('aria-busy');
            const j = o.ok ? o.json : null;
            if (!(j && !j.error && typeof j.result.html === 'string')) { avisoFila(href); return; }
            if ($) $(lista).html(j.result.html); else lista.innerHTML = j.result.html;
            history.pushState(history.state, '', href);
            pintarTags(lista);
            ligarPopovers(lista);
            const alvo = lista.querySelector('.op-card-abrir') || lista;
            if (alvo === lista) lista.tabIndex = -1;
            alvo.focus({ preventScroll: false });
        });
    };

    // ---------- boxes B-2/B-3 (EP-03) ----------
    const contar = () => {
        if (contado) return;
        contado = true;
        const caixa = document.querySelector('.op-tela .op-boxes[data-url]');
        if (!caixa) return;
        const falha = caixa.dataset.falha || '';
        const pinta = (box, n) => {
            const b = box.querySelector('b');
            if (!b) return;
            b.removeAttribute('aria-busy');
            if (n === null || n === undefined || typeof n !== 'number') { b.textContent = '—'; box.title = falha; return; }
            b.textContent = n.toLocaleString('pt-BR');
            box.removeAttribute('title');
        };
        pedir(caixa.dataset.url).then((o) => {
            const r = o.ok && !o.json.error ? o.json.result : null;
            caixa.querySelectorAll('[data-box="atrasadas"]').forEach(box => pinta(box, r ? r.atrasadas : null));
            caixa.querySelectorAll('[data-box="etapa"][data-pendente]').forEach((box) => {
                if (r && r.etapas === null) { box.remove(); return; }   // não se aplica (tipo ≠ 1, sem funil): DD-09, sem buraco
                pinta(box, r && r.etapas ? r.etapas[box.dataset.etapa] : null);
            });
        });
    };

    // ---------- filtros ----------
    const form = () => document.querySelector('.op-tela form.op-form');
    const enviar = () => { const f = form(); if (!f) return; if (typeof f.requestSubmit === 'function') f.requestSubmit(); else f.submit(); };
    const avancado = () => document.getElementById('op-avancado');
    const abrirAvancado = (abre, foco) => {
        const p = avancado();
        if (!p) return;
        p.hidden = !abre;
        document.querySelectorAll('.op-tela [aria-controls="op-avancado"]').forEach(b => b.setAttribute('aria-expanded', abre ? 'true' : 'false'));
        if (abre) { const c = p.querySelector('select, input, button'); if (c) c.focus(); }
        else if (foco) { const chip = Array.from(document.querySelectorAll('.op-tela [aria-controls="op-avancado"]')).find(b => b.offsetParent !== null); if (chip) chip.focus(); }
    };

    const aoClicar = (e) => {
        const alvo = e.target instanceof Element ? e.target : null;
        if (!alvo || !tela.contains(alvo)) return;
        // card: abrir
        const ab = alvo.closest('.op-card-abrir');
        if (ab) {
            if (ab.disabled) return;
            if ((vista() !== 'cards' && tela.dataset.estagio !== 'encolhida') || !ab.dataset.detalhe) {   // Funil/Tabela em L1: GET com sel (CA-23)
                if (ab.dataset.sel) location.assign(ab.dataset.sel); return; }
            const card = ab.closest('.op-card');
            abrir(ab, ab.dataset.detalhe, ab.dataset.sel, card ? card.id.replace('opportunity_', '') : null, ab.dataset.pagina || null);
            return;
        }
        // atalhos do card (Conversa, Telefonar) = abrir o card
        const ir = alvo.closest('.op-card-ir');
        if (ir) { const b = ir.closest('.op-card') ? ir.closest('.op-card').querySelector(':scope > .op-card-abrir') : null; if (b && !b.disabled) b.click(); return; }
        // tabela: linha ou nome
        const tr = alvo.closest('tr[data-sel]');
        if (tr && !alvo.closest('a, button:not(.op-tab-abrir), input, select')) { location.assign(tr.dataset.sel); return; }
        // estados do detalhe
        const tentar = alvo.closest('.op-estado-tentar');
        if (tentar && tentar.dataset.url) { const id = (det.querySelector('.op-barra[data-ticket]') || {}).dataset; abrir(null, tentar.dataset.url, null, id ? id.ticket : null, null); return; }
        const pt = alvo.closest('.op-pedidos-tentar');
        if (pt) {   // E-D10d: refaz só o GET do resumo; o foco fica no bloco (o botão sai com o esqueleto)
            const bloco = pt.closest('.op-barra-nums[data-resumo-url]');
            if (!bloco) return;
            const tinhaFoco = document.activeElement === pt;
            carregarResumo(bloco);
            if (tinhaFoco) { bloco.tabIndex = -1; bloco.focus({ preventScroll: true }); }
            return;
        }
        const ct = alvo.closest('.op-conversa-tentar');
        if (ct) {   // E-D11c: refaz o MESMO GET (EP-08 ou a url do canal escolhido); o foco fica na raiz (o botão sai com o esqueleto)
            const raiz = ct.closest('#op-conversa-chat');
            const g = raiz ? ultimoGet.get(raiz) || { url: raiz.dataset.url, canal: null } : null;
            if (!g) return;
            const tinhaFoco = document.activeElement === ct;
            carregarConversa(raiz, g.url, g.canal);
            if (tinhaFoco) { raiz.tabIndex = -1; raiz.focus({ preventScroll: true }); }
            return;
        }
        const rs = alvo.closest('.op-barra > .op-barra-resumo');
        if (rs) {   // C-12: só alterna; o foco fica no botão (Enter/Espaço nativos do <button type=button>)
            detalhesAberto = rs.getAttribute('aria-expanded') !== 'true';
            rs.setAttribute('aria-expanded', detalhesAberto ? 'true' : 'false');
            return;
        }
        const ci = alvo.closest('.op-canais .op-canal-item[data-canal]');
        if (ci) { trocarCanal(ci); return; }
        if (alvo.closest('.op-barra-fechar')) { SaidaDetalhe.fechar(null); return; }   // × da barra, do esqueleto (E-D2) e dos estados
        if (alvo.closest('.op-col-tentar')) { location.reload(); return; }   // E-L9: recarrega a vista
        // paginação (só a vista Cards e a fila encolhida, onde o #op-lista é a região fila-card)
        const pg = alvo.closest('#op-lista[data-regiao="fila-card"] .op-pag a[href]');
        if (pg && e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) { e.preventDefault(); paginar(pg.href); return; }
        const ft = alvo.closest('.op-fila-tentar');
        if (ft) { paginar(ft.dataset.url || location.href); return; }
        // chips liga/desliga (Atrasadas, Descartados)
        const chip = alvo.closest('.op-filtros .tk-chip[data-filtro][data-campo-alvo]');
        if (chip) {
            const campo = document.getElementById(chip.dataset.campoAlvo);
            if (campo) { campo.value = chip.getAttribute('aria-pressed') === 'true' ? '' : chip.dataset.valor; enviar(); }
            return;
        }
        const et = alvo.closest('.op-etapa-item[data-etapa]');
        if (et) { e.preventDefault(); const c = document.getElementById('input-change-category'); if (c) { c.value = et.dataset.etapa; enviar(); } return; }
        if (alvo.closest('[aria-controls="op-avancado"]')) { const p = avancado(); abrirAvancado(!!p && p.hidden, true); return; }
        if (alvo.closest('.op-avancado-fechar')) { abrirAvancado(false, true); return; }
        const lb = alvo.closest('.op-busca-limpar');
        if (lb) {
            const inp = document.querySelector('.op-tela .op-busca input[type="search"]');
            if (!inp) return;
            const aplicada = lb.dataset.aplicada === '1';
            inp.value = '';
            if (aplicada) enviar(); else { lb.hidden = true; inp.focus(); }
        }
    };
    const aoTeclar = (e) => {
        if (e.key !== 'Escape' || e.defaultPrevented) return;
        const p = avancado();
        if (p && !p.hidden && p.contains(document.activeElement) && !document.querySelector('.select2-container--open')) { e.preventDefault(); abrirAvancado(false, true); }
    };
    // Esc, degraus da página antes da escada do SaidaDetalhe (que ouve na captura do document): esta captura é na window, roda antes.
    // UI-51 / ui.md §A11y: fecha menu > gaveta > (janela 5 > detalhe, do SaidaDetalhe). Swal e modal BS4 têm o Esc deles.
    const emCampo = (el) => !!el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable);
    const aoEsc = (e) => {
        if (e.key !== 'Escape' || e.defaultPrevented) return;
        if ((window.Swal && typeof window.Swal.isVisible === 'function' && window.Swal.isVisible()) || document.querySelector('.modal.show')) return;
        // C-16d DD-31: o menu "Etapa" mora em #op-etapa-dd, fora do .dropdown do chip; o Esc do BS4 4.5 procura o toggle DENTRO do pai (data-target) e
        // não acha: fecha sem devolver o foco ([MEDIR] v15). Aqui fecha pelo próprio chip e devolve o foco a ele (UI-118).
        const etapa = document.querySelector('#op-etapa-dd .op-etapa-menu.show');
        if (etapa) {
            e.preventDefault(); e.stopPropagation();
            const chip = document.querySelector('.op-tela .op-chip-etapa[data-target="#op-etapa-dd"]');
            if (chip && $ && $.fn && $.fn.dropdown) $(chip).dropdown('hide');
            if (chip) { chip.setAttribute('aria-expanded', 'false'); chip.focus(); }   // o hide() do BS4 4.5 não mexe no aria-expanded (só o clearMenus)
            return;
        }
        const menu = det.querySelector('.op-mais-menu.show');
        if (menu) {
            e.preventDefault();
            const b = menu.parentElement.querySelector('[data-toggle="dropdown"]');
            if (b && $ && $.fn && $.fn.dropdown) $(b).dropdown('hide');
            if (b) b.focus();
            return;
        }
        const a = document.activeElement;
        const ctx = a && a.closest && !emCampo(a) ? a.closest('.op-corpo[data-ctx="aberto"] > .op-ctx') : null;
        if (ctx) { e.preventDefault(); const x = ctx.querySelector('.op-ctx-fechar'); if (x) x.click(); }   // o TelaPaineis fecha e devolve o foco ao "Contexto"
    };
    const aoDigitar = (e) => {
        const inp = e.target instanceof Element ? e.target.closest('.op-tela .op-busca input[type="search"]') : null;
        if (!inp) return;
        const lb = inp.parentElement.querySelector('.op-busca-limpar');
        if (lb && lb.dataset.aplicada !== '1') lb.hidden = inp.value === '';
    };

    return {
        MAPA,
        init: function () {
            tela = document.querySelector('.op-tela');
            fila = document.getElementById('op-fila');
            det = document.getElementById('opp27-detalhe');
            lista = document.getElementById('op-lista');
            if (!tela || !fila || !det || !lista) return;   // só na página oportunidades-2027
            SaidaDetalhe.init(Object.assign({}, MAPA.saida, { aoEsvaziar: aoEsvaziar }));
            FilaSelecao.init(MAPA.fila);
            PainelOlho.init(MAPA.olho);
            TelaPaineis.init(MAPA.paineis);
            document.addEventListener('click', aoClicar);   // depois do FilaSelecao: ele arma a trava antes deste abrir
            document.addEventListener('keydown', aoTeclar);
            window.addEventListener('keydown', aoEsc, true);
            document.addEventListener('input', aoDigitar);
            document.addEventListener('op:detalhe', geolocalizar);   // F-99
            if ($) $(document).on('show.bs.dropdown', '.op-tela .op-canais', medirMenuCanais);   // R-24
            pintarTags(tela);
            ligarPopovers(tela);
            if (tela.dataset.estagio === 'cheia') contar();
            // C-16 DD-30: o pós-ação usa as MESMAS peças desta tela (pedir, abrir, avisoFila, comSelAtual), nunca uma segunda cópia
            PosAcao.init({
                tela: tela, fila: fila, lista: lista, det: det, pedir: pedir, abrir: abrir, estado: estado, clonar: clonar, avisoFila: avisoFila,
                comSelAtual: comSelAtual, pintarTags: pintarTags, ligarPopovers: ligarPopovers, aplicarDetalhes: aplicarDetalhes, carregarResumo: carregarResumo, vista: vista,
                recontar: () => { contado = false; if (tela.dataset.estagio === 'cheia') contar(); },   // DD-30 item 5
            });
            // L2 vindo da URL (`sel`): abre pelo card da página; sem o card (outra página da lista), pelo endereço do view-model
            const sel = tela.dataset.sel || '';
            if (tela.hasAttribute('data-sel-invalido')) { estado('op-tpl-ed4', null, null, null); return; }
            if (sel) {
                const b = document.querySelector('#opportunity_' + CSS.escape(sel) + ' > .op-card-abrir');
                if (b) b.click();
                else if (det.dataset.detalheSel) abrir(null, det.dataset.detalheSel, null, sel, null);
            }
        },
    };
}();

module.exports = Oportunidades27;
